import { jsPDF } from "jspdf";

const BLUE = [29, 78, 216];
const ORANGE = [249, 115, 22];
const DARK = [15, 23, 42];
const GRAY = [100, 116, 139];
const SKY = [125, 211, 252];

const clean = (t) => String(t).replace(/₹/g, "Rs. ").replace(/[^\x00-\xFF]/g, (c) => {
  const map = { "—": "--", "–": "-", "→": "->", "×": "x", "’": "'", "‘": "'", "“": '"', "”": '"' };
  return map[c] || "-";
});

export const downloadSyllabus = (course, trainer, cat, price) => {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = 595;
  const M = 48;
  const CW = W - M * 2;
  let y = 0;

  const footer = () => {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.setTextColor(...GRAY);
    doc.text("LearnWithTAC  |  learnwithtac.com  |  info@learnwithtac.com  |  WhatsApp: +1 559 813 7277", M, 822);
    doc.setTextColor(...ORANGE);
    doc.text("TRAIN 1-ON-1  -  PRACTICE 24x7  -  GET HIRED", M, 832);
  };

  const checkPage = (need = 40) => {
    if (y + need > 790) {
      footer();
      doc.addPage();
      y = 56;
    }
  };

  const heading = (text) => {
    checkPage(56);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    doc.setTextColor(...BLUE);
    doc.text(clean(text), M, y);
    y += 8;
    doc.setDrawColor(...ORANGE);
    doc.setLineWidth(2);
    doc.line(M, y, M + 38, y);
    y += 15;
  };

  const para = (text) => {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(...DARK);
    doc.splitTextToSize(clean(text), CW).forEach((ln) => {
      checkPage(16);
      doc.text(ln, M, y);
      y += 14;
    });
  };

  const bullets = (items) => {
    doc.setFontSize(10);
    items.forEach((it) => {
      const lines = doc.splitTextToSize(clean(it), CW - 16);
      lines.forEach((ln, li) => {
        checkPage(16);
        if (li === 0) {
          doc.setTextColor(...ORANGE);
          doc.setFont("helvetica", "bold");
          doc.text("*", M + 2, y);
        }
        doc.setTextColor(...DARK);
        doc.setFont("helvetica", "normal");
        doc.text(ln, M + 14, y);
        y += 14;
      });
    });
  };

  doc.setFillColor(6, 9, 19);
  doc.rect(0, 0, W, 112, "F");
  doc.setFillColor(...ORANGE);
  doc.rect(0, 112, W, 4, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text("LEARNWITHTAC  -  1-ON-1 ENGINEERING TRAINING  -  LEARNWITHTAC.COM", M, 38);
  doc.setFontSize(21);
  doc.splitTextToSize(clean(course.title), CW).forEach((ln, i) => doc.text(ln, M, 68 + i * 24));
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(...SKY);
  doc.text(clean(`${cat.name}  |  ${course.level}  |  ${course.duration} (${course.hours})  |  1-on-1 Live Online`), M, 100);
  y = 146;

  heading("Course Overview");
  para(course.overview);
  y += 10;

  heading("Course Content (Modules)");
  bullets(course.modules);
  y += 10;

  heading("What You Will Learn - Topic by Topic");
  bullets(course.topics);
  y += 10;

  heading("Hands-on Labs You Will Perform");
  bullets(course.labs.map((l, i) => `Lab ${i + 1}: ${l}`));
  y += 10;

  if (course.exam) {
    heading("Certification Exam Details");
    bullets([
      `Exam: ${course.exam.code}`,
      `Duration: ${course.exam.duration}`,
      `Format: ${course.exam.questions}`,
      `Validity: ${course.exam.validity}`,
      `Exam Fee (paid to vendor): ${course.exam.cost}`,
    ]);
    y += 10;
  }

  heading("Prerequisites");
  bullets(course.prerequisites);
  y += 10;

  heading("Who Can Do This Course");
  bullets(course.audience);
  y += 10;

  heading("Career Opportunities & Salary");
  bullets([...course.jobs, `India: ${course.salary.india}   |   Global: ${course.salary.global}`]);
  y += 10;

  heading("Your Trainer");
  bullets([
    `${trainer.name} - ${trainer.role}, ${trainer.company}`,
    `${trainer.experience} - ${trainer.detail}`,
    `Specialization: ${trainer.specialization}`,
  ]);
  y += 10;

  heading("What's Included & Fee");
  bullets([
    "Live 1-on-1 training sessions with flexible timing",
    "Live class recordings after every session",
    "24x7 dedicated lab pod access",
    "Trainer-written notes PDF & lab workbooks",
    "1-on-1 mentor support channel",
    "Mock interviews, resume building & placement assistance",
    "Course completion certificate with unique ID",
    `Course fee: ${clean(price)} (one-time, EMI options available)`,
    "Free demo session before enrollment",
  ]);

  footer();
  doc.save(`LearnWithTAC-${course.slug}-syllabus.pdf`);
};
